<template>
  <div class="valid-account">
    <v-row class="margin-b-10" no-gutters>
      <v-col cols="12" sm="12" md="12" class="position--relative px-0">
        <v-menu
          v-model="showAllowBanks"
          :close-on-content-click="false"
          offset-y
          max-width="100%"
          min-width="100%"
          content-class="account__bank-menu"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="d-flex account__select align-center justify-space-between"
              v-on="on"
              v-bind="attrs"
              :style="isDisabled ? 'cursor: not-allowed;' : ''"
              style="height: 46px; border-radius: 4px; border: solid 1px #e7edf6"
            >
              <template v-if="inputBankCode">
                <p class="d-flex ma-0 align-center width-100">
                  <img
                    class="margin-r-10 bank__image"
                    :src="bankImageSrc(inputBankCode)"
                  />
                  {{ inputBankName }}
                </p>
              </template>
              <template v-else>
                <p class="d-flex ma-0 align-center font-weight-bold">
                  은행을 선택해 주세요.
                </p>
              </template>
              <span class="detail-arrow" :class="{ active: showAllowBanks }"></span>
            </div>
          </template>

          <v-list v-if="renderBanks && renderBanks.length > 0">
            <v-list-item
              v-for="allowBank in renderBanks"
              :key="allowBank.code"
              @click="selectBank(allowBank)"
            >
              <v-list-item-avatar>
                <img class="bank__image" :src="bankImageSrc(allowBank.code)" />
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ allowBank.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <div v-else class="pa-3">현재 은행목록을 불러올 수 없습니다. 페이지를 새로고침해주세요.</div>
        </v-menu>
      </v-col>
    </v-row>

    <v-row class="margin-b-5" no-gutters>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-row :class="{ 'd-flex': !isMobile }" no-gutters>
          <v-col
            cols="12"
            sm="12"
            md="7"
            :class="isMobile ? 'margin-b-10' : 'padding-r-15'"
          >
            <input
              v-model="inputAccountNo"
              :disabled="isDisabled"
              class="width-100"
              placeholder="계좌번호를 입력해주세요"
              numberonly
              style="
                font-size: 15px;
                height: 46px;
                border-radius: 4px;
                border: solid 1px #e7edf6;
                box-shadow: none;
                padding: 6px 12px;
              "
            />
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="5"
            class="px-0"
            :class="{ 'width-100': isMobile }"
          >
            <v-btn
              class="width-100 font-size--15 white--text"
              color="#333333"
              style="height: 46px; border-radius: 4px"
              tile
              :disabled="
                isDisabled ||
                  valid.validLoading ||
                  !!!this.inputBankCode ||
                  !!!this.inputAccountNo
              "
              :loading="valid.validLoading"
              @click="validAccount()"
            >
              계좌 조회하기
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="12" md="12" class="px-0">
            <p
              class="error--text font-size--13 line-height--16 margin-t-7 mb-0"
            >
              ※ 적금, 휴면 계좌의 경우 송금이 불가능하오니 예금 계좌로
              입력해주세요.
            </p>
            <p class="my-2 error--text font-size--13">
              ※ 등록된 계좌 외에는 예치금 입,출금이 제한됩니다.
            </p>
          </v-col>

          <v-col v-if="showAccountName" cols="12" sm="6" md="6" class="mt-3">
            <v-text-field
              v-model="accountForm.accountName"
              disabled
              readonly
              outlined
              hide-details
              label="예금주"
              placeholder="계좌 조회를 진행해주세요"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { CodeTypes } from '@/store/types/code'

export default {
  props: {
    isDisabled: Boolean,
    showAccountName: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showAllowBanks: false,
      banks: [],
      accountForm: {
        bankCode: null,
        accountNo: null,
        accountName: null,
      },
      inputBankCode: null,
      inputBankName: null,
      inputAccountNo: null,
      valid: {
        validLoading: false,
      },
    }
  },
  computed: {
    renderBanks() {
      if (!Array.isArray(this.banks)) return []
      // 배열을 렌더링 친화적인 단순 객체로 정규화
      return this.banks.map(b => ({
        code: String(b && b.code != null ? b.code : ''),
        name: String(b && b.name != null ? b.name : ''),
      }))
    },
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
  },
  mounted() {
    console.log('ValidAccount mounted - banks:', this.banks)
    console.log('ValidAccount mounted - isDisabled:', this.isDisabled)
  },
  watch: {
    inputBankCode: function(v) {
      if (!!this.accountForm.accountName && this.accountForm.bankCode !== v) {
        this.accountForm.accountName = null
      }
    },
    inputAccountNo: function(v) {
      if (!!this.accountForm.accountName && this.accountForm.accountNo !== v) {
        this.accountForm.accountName = null
      }
    },
    'accountForm.accountName': function() {
      this.$emit('valid-account-form', this.accountForm)
    },
  },
  async created() {
    try {
      const result = await this.getBanks()
      // API 응답을 안전하게 정규화하여 렌더링 이슈 방지
      this.banks = Array.isArray(result)
        ? result.map(b => ({ code: b.code, name: b.name }))
        : []
      console.log('은행 정보:', this.banks)
    } catch (error) {
      console.error('은행 정보 조회 실패:', error)
      this.$swal.basic.alert('은행 정보를 불러올 수 없습니다. 페이지를 새로고침해주세요.')
    }
  },
  methods: {
    ...mapActions('code', {
      getBanks: CodeTypes.actions.GET_BANKS,
    }),
    bankImageSrc(code) {
      try {
        // webpack의 require.context로 이미지 안전 로딩
        const ctx = require.context('@/assets/images/common/banks', false, /\.jpg$/)
        const path = `./${String(code)}.jpg`
        if (ctx.keys().includes(path)) {
          return ctx(path)
        }
        // 기본 이미지로 대체
        const fallback = './default.jpg'
        if (ctx.keys().includes(fallback)) {
          return ctx(fallback)
        }
      } catch (e) {
        console.error('은행 이미지 로딩 실패:', code, e)
      }
      return ''
    },
    onClickCodeSelectBar() {
      console.log('은행 선택 클릭 - isDisabled:', this.isDisabled, 'banks:', this.banks)
      if (this.isDisabled) {
        console.log('disabled 상태여서 클릭 불가')
        return
      }
      this.showAllowBanks = !this.showAllowBanks
      console.log('showAllowBanks 상태:', this.showAllowBanks)
    },
    selectBank(bank) {
      this.inputBankCode = bank.code
      this.inputBankName = bank.name
      this.showAllowBanks = false
    },
    async validAccount() {
      let alert = await this.$swal.basic.confirm(
        '계좌 조회를 진행하시겠습니까?'
      )
      if (!alert.isConfirmed) {
        return
      }

      if (!!!this.inputBankCode || !!!this.inputAccountNo) {
        return
      }

      this.valid.validLoading = true

      let q = `
        data: getPaymentAccountInfo(bankCode: "${this.inputBankCode}", accountNo: "${this.inputAccountNo}"){
            realAccountName
            isSearch
        }
      `

      try {
        let data = await this.$fundaApi.query(gql`{${q}}`)

        if (!!data) {
          let result = data
          if (result.isSearch) {
            this.accountForm.bankCode = this.inputBankCode
            this.accountForm.accountNo = this.inputAccountNo
            this.accountForm.accountName = result.realAccountName

            this.$swal.basic.alert({
              html: `예금주 <br /> <br /> 
              <b class="font-size--17">
                ${result.realAccountName}
              </b>
              <br />
              <br />
              위 정보가 맞는지 확인 후 진행해주세요
              `,
            })
          } else {
            this.$swal.basic.alert('올바르지 않은 계좌입니다.')
          }
        } else {
          this.$swal.basic.alert(
            '계좌조회에 실패했습니다. 문제가 지속되면 문의바랍니다.'
          )
        }
      } catch (e) {
        this.$swal.basic.alert(e.message)
      } finally {
        this.valid.validLoading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.valid-account .btn-funda-basic,
.valid-account .btn-funda-basic--reverse {
  padding: 10px 24px;
  border-radius: 3px;
}

.valid-account .bank__image {
  max-width: 110px;
}

.valid-account .account__select {
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: solid 1px #ccc;
  border-radius: 3px;
  cursor: pointer;
}

.valid-account .account__select .detail-arrow {
  content: '';
  margin-top: 0;
  left: unset;
  right: 15px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #747474;
}

.valid-account .account__select .detail-arrow.active {
  border-top: unset;
  border-bottom: 6px solid #747474;
}

.valid-account .account__bank-list {
  position: absolute;
  width: 100%;
  max-height: 300px;
  background-color: white;
  border: solid 1px #ccc;
  box-shadow: none;
  list-style: none;
  overflow: scroll;
  z-index: 99;
  top: 48px;
  left: 0;
}

.valid-account .account__bank-menu {
  max-height: 320px;
  overflow-y: auto;
  border: 1px solid #ccc;
  background-color: #fff;
  z-index: 2000;
}

.valid-account .account__bank-list li p {
  padding: 10px 12px;
  border-bottom: solid 1px #ddd;
  cursor: pointer;
}

.valid-account .account__bank-list li p:hover,
.valid-account .account__bank-list li p.active {
  background-color: #f9f9f9 !important;
  font-weight: bold;
}

.valid-account .attention {
  color: #f9356a;
  font-size: 13px;
}
</style>
